export default __webpack_public_path__ + "static/media/off.9b4a4b0f.png";